import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const GuessingGame = () => {
    const [targetNumber, setTargetNumber] = useState(Math.floor(Math.random() * 100) + 1);
    const [guess, setGuess] = useState('');
    const [message, setMessage] = useState('');

    const handleGuess = () => {
        const guessedNumber = parseInt(guess, 10);
        if (guessedNumber === targetNumber) {
            setMessage('おめでとうございます！正解です！');
        } else if (guessedNumber < targetNumber) {
            setMessage('もっと大きな数字です！');
        } else {
            setMessage('もっと小さな数字です！');
        }
    };

    const handleInputChange = (event) => {
        setGuess(event.target.value);
    };

    const handleReset = () => {
        setTargetNumber(Math.floor(Math.random() * 100) + 1);
        setGuess('');
        setMessage('');
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>数当てゲーム</h1>
            <p>1から100の数字を当ててください。</p>
            <input
                type="number"
                value={guess}
                onChange={handleInputChange}
                placeholder="数字を入力"
            />
            <button onClick={handleGuess}>推測</button>
            <p>{message}</p>
            <button onClick={handleReset}>ゲームをリセット</button>
            <br />
            <Link to="/" style={{ marginTop: '20px', display: 'inline-block' }}>
                <button>Homeに戻る</button>
            </Link>
        </div>
    );
};

export default GuessingGame;
